module.exports = __webpack_public_path__ + "img/IRL.89956b66.svg";